import React from 'react';

const PdfIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 67 67" fill="none">
            <rect width="67" height="67" fill="#F5F5F5" />
            <mask id="mask0_2569_3796" maskUnits="userSpaceOnUse" x="9" y="10" width="48" height="48">
                <rect x="9" y="10" width="48" height="48" fill="#D9D9D9" />
            </mask>

            <g mask="url(#mask0_2569_3796)">
                <path
                    d="M25.55 36.45H27.4V32.3H29.8C30.3243 32.3 30.7637 32.1227 31.118 31.768C31.4727 31.4133 31.65 30.974 31.65 30.45V28.05C31.65 27.526 31.4727 27.0867 31.118 26.732C30.7637 26.3773 30.3243 26.2 29.8 26.2H25.55V36.45ZM27.4 30.45V28.05H29.8V30.45H27.4ZM33.85 36.45H38.05C38.55 36.45 38.9833 36.2727 39.35 35.918C39.7167 35.5637 39.9 35.1243 39.9 34.6V28.05C39.9 27.526 39.7167 27.0867 39.35 26.732C38.9833 26.3773 38.55 26.2 38.05 26.2H33.85V36.45ZM35.7 34.6V28.05H38.05V34.6H35.7ZM42.35 36.45H44.2V32.3H46.7V30.45H44.2V28.05H46.7V26.2H42.35V36.45ZM22 48C21.2 48 20.5 47.7 19.9 47.1C19.3 46.5 19 45.8 19 45V17C19 16.2 19.3 15.5 19.9 14.9C20.5 14.3 21.2 14 22 14H50C50.8 14 51.5 14.3 52.1 14.9C52.7 15.5 53 16.2 53 17V45C53 45.8 52.7 46.5 52.1 47.1C51.5 47.7 50.8 48 50 48H22ZM22 45H50V17H22V45ZM16 54C15.2 54 14.5 53.7 13.9 53.1C13.3 52.5 13 51.8 13 51V20H16V51H47V54H16Z"
                    fill="#C4C4C4"
                />
            </g>
        </svg>
    );
};

export default PdfIcon;
